<script lang="ts" setup>
import { DefaultButton } from '@hantecmarket/hantec-ui-widget'

import { defaultProps } from '@/components/AcuityComponents/InsightProSection/InsightProSection.constants'
import { resolveButterUrl } from '@/utils/utils'

import type { SponsorhipContentTypes } from '@/components/SponsorhipOverview/SponsorshipOverviewContent.types'

withDefaults(defineProps<SponsorhipContentTypes>(), defaultProps as any)
</script>

<template>
  <div
    :class="backgroundColor === 'white' ? 'bg-white' : 'bg-gray-50'"
    class="flex justify-center w-full"
  >
    <div class="px-2.5 py-20 md:px-20 lg:px-30 lg:py-40 max-w-1440 mx-auto">
      <h2 class="mb-20 text-center h3-bold md:h2-bold" v-html="title"></h2>
      <div
        :class="align === 'left' ? 'xl:flex-row' : 'xl:flex-row-reverse'"
        class="flex flex-col gap-10 lg:gap-30"
      >
        <div class="self-center xl:self-start">
          <img class="rounded-2.5" :src="image" />
        </div>
        <div class="flex flex-col justify-between flex-1">
          <div v-html="content" class="leading-normal"></div>
          <div class="flex justify-center mt-10 xl:justify-start 1440:mt-0">
            <DefaultButton
              v-if="button?.title && button?.href"
              :href="resolveButterUrl(button.href)"
              class="max-w-[170px] lg:whitespace-nowrap flex-1 lg:px-8 py-4 flex items-center button rounded-1.5 leading-normal font-bold h-12.5 justify-center bg-red-150 text-white"
            >
              {{ button.title }}
            </DefaultButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
